<template>
  <el-date-picker :size="size" class="width-xxx" type="date" placeholder="选择日期"
                  :value="cValue" @input="handleInput" @change="emitChange"
  >
  </el-date-picker>
</template>

<script>
  import {optionalValueMixin} from '../../../mixins/optional-value'

  export default {
    name: 'input-date',
    mixins: [optionalValueMixin],
    props: {
      size: {
        type: String,
        default: 'mini'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/inputs/input-date.vue